import { Collapse } from "antd";

import { useAuthStore } from "@/stores/authStore";
import { RenewPledgeItem } from "@/stores/usePledgesStore";
import { PaymentAmountDetail } from "@/types/pledgeService";

import styles from "../PriceSummaryModal.module.css";

interface Props {
  details: PaymentAmountDetail[];
  pledges: RenewPledgeItem[];
}

const PledgesDetailsBreakdown: React.FC<Props> = ({ details, pledges }) => {
  const { currency } = useAuthStore();
  const getPledgeNumber = (id: number): string => {
    const pledgeNumber = pledges?.find((item) => item?.id === id);
    return pledgeNumber?.ticket_alpha_code as string;
  };
  return (
    <Collapse
      defaultActiveKey={[]}
      className={styles.collapseWrapper}
      items={[
        {
          key: "pledge-details",
          label: <div className={styles.promotionSectionTitle}>Pledge Breakdown Details</div>,

          children: (
            <div>
              {details?.map((item) => (
                <div key={item?.pledge_id} className={styles.pledgeDetailsSection}>
                  <div className={styles.pledgeDetailsItem}>
                    <span>Pledge Ticket Number</span>
                    <span>{getPledgeNumber(item?.pledge_id)}</span>
                  </div>

                  <div className={styles.pledgeDetailsItem}>
                    <span>{`Pledge Amount (${currency})`}</span>
                    <span>{item?.pledge_amount ?? 0}</span>
                  </div>

                  <div className={styles.pledgeDetailsItem}>
                    <span>{`Pledge Interest Amount (${currency})`}</span>
                    <span>{item?.interest_amount ?? 0}</span>
                  </div>

                  {item?.downloan_amount && (
                    <div className={styles.pledgeDetailsItem}>
                      <span>{`Pledge Downloan Amount (${currency})`}</span>
                      <span>{item?.downloan_amount}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ),
        },
      ]}
    />
  );
};

export default PledgesDetailsBreakdown;
